import { useState, useCallback } from 'react';
import { Snackbar, Alert } from '@mui/material';

/**
 * 计算根据分数获得的积分
 * @param {number} score - 提交分数 (0-100)
 * @returns {number} 获得的积分
 */
export const calculatePointsFromScore = (score) => {
  if (score >= 10) {
    return Math.floor(score / 10);
  } else if (score > 0) {
    return 1;
  }
  return 0;
};

/**
 * 全局通知系统 Hook
 * 用于显示临时通知消息（如积分增加、徽章获得等）
 */
export const useNotification = () => {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback((message, type = 'success', duration = 4000) => {
    setNotification({
      message,
      type,
      duration
    });
  }, []);

  const hideNotification = useCallback(() => {
    setNotification(null);
  }, []);

  /**
   * 显示积分增加通知
   * @param {number} score - 提交分数
   * @param {number} pointsEarned - 获得的积分（可选，如果不提供则根据分数计算）
   */
  const showPointsNotification = useCallback((score, pointsEarned = null) => {
    const points = pointsEarned !== null ? pointsEarned : calculatePointsFromScore(score);
    if (points > 0) {
      showNotification(
        `🎉 恭喜！获得 ${points} 积分（分数：${score}/100）`,
        'success',
        5000
      );
    }
  }, [showNotification]);

  const NotificationComponent = () => {
    if (!notification) return null;

    return (
      <Snackbar
        open={!!notification}
        autoHideDuration={notification.duration}
        onClose={hideNotification}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{ mt: 8 }}
      >
        <Alert
          onClose={hideNotification}
          severity={notification.type}
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    );
  };

  return {
    showNotification,
    showPointsNotification,
    hideNotification,
    NotificationComponent
  };
};
